import { useQuery } from '@tanstack/react-query';
import { fetchDropdownOptions } from '../utils';

export const loadFilterV2QueryKeys = {
  dropdownOptions: (isEPO, isEORIUser) => ['loadFilterV2DropdownOptions', isEPO, isEORIUser],
};

export const useLoadFilterOptions = ({ isEPO, isEORIUser, enabled = true }) => {
  const optionsQuery = useQuery({
    queryKey: loadFilterV2QueryKeys.dropdownOptions(isEPO, isEORIUser),
    queryFn: () => fetchDropdownOptions(isEPO, isEORIUser),
    enabled,
    staleTime: Infinity,
  });

  return {
    dropdownOptions: {
      statuses: [],
      agents: [],
      routes: [],
      customerNames: [],
      customerEoris: [],
      siteNames: [],
      epoTypes: [],
      ...optionsQuery.data,
      isLoaded: optionsQuery.isSuccess,
    },
    isLoading: enabled && optionsQuery.isPending,
    isError: optionsQuery.isError,
  };
};
